import { TooltipProvider } from '@visx/xychart';

export const CursorProvider = ({ children }: { children: React.ReactNode }) => {
  return <TooltipProvider>{children}</TooltipProvider>;
};
